export default "__VITE_ASSET__BriV7RdR__"